// Queue acknowledgement only, on a separate lane from identity checks and
// scanner input. The durable shared runtime owns the actual pricing work.
export function createScanPricingQueue({enqueue,onResult,delayMs=150,retryMs=2000}){
 const waiting=new Set(),pending=new Set(),accepted=new Set();let timer=null,active=false,closed=false;
 function schedule(delay=delayMs){if(!closed&&!active&&!timer&&waiting.size)timer=setTimeout(()=>{timer=null;void flush();},delay);}
 async function flush(){
  if(closed||active)return;
  const certs=[...waiting].slice(0,84);if(!certs.length)return;
  for(const c of certs)waiting.delete(c);active=true;
  let reply;
  for(let attempt=0;attempt<2&&!closed;attempt++){
   try{reply=await enqueue(certs);}catch{reply={status:'unavailable'};}
   if(reply.status!=='unavailable')break;
   if(attempt===0)await new Promise(resolve=>setTimeout(resolve,retryMs));
  }
  if(!closed){
   for(const cert of certs){
    const status=reply?.status==='paused'?'paused':reply?.checks?.find(c=>c.cert===cert)?.status||'unavailable';
    if(['queued','working','complete'].includes(status))accepted.add(cert);
    pending.delete(cert);
    onResult(cert,status);
   }
  }
  active=false;schedule();
 }
 return {
  enqueue(cert,retry=false){if(retry)accepted.delete(cert);if(closed||accepted.has(cert)||pending.has(cert))return;pending.add(cert);waiting.add(cert);onResult(cert,'submitting');schedule();},
  close(){closed=true;clearTimeout(timer);waiting.clear();}
 };
}
export const scanPricingLabel=status=>({submitting:'Starting ACE / PSA price check…',queued:'ACE / PSA pricing queued',working:'Checking ACE / PSA sales…',complete:'ACE / PSA price check up to date',failed:'Price check needs review',paused:'Pricing paused · scans can still be saved',unavailable:'Pricing unavailable · scans can still be saved'}[status]||'');
